// Groessenberater: aus der gewohnten Groesse und der Wunschpassform eine
// Groesse vorschlagen und ihre Maße zeigen. Die Tabelle steht als JSON im
// Markup, gerechnet wird im Browser - kein Nachladen, kein Server, keine
// Daten, die irgendwo landen.
//
// Warum nicht Koerpergroesse und Gewicht: die einzige belastbare Quelle ist
// die Groessentabelle, und die nennt Maße des Shirts. Von Koerpergroesse auf
// Konfektionsgroesse zu schliessen waere geraten.

const beraterListe = document.querySelectorAll('[data-fn-groessenberater]');

const massZeile = (label, wert) =>
    wert ? '<div><dt>' + label + '</dt><dd>' + wert + '&nbsp;cm</dd></div>' : '';

beraterListe.forEach((berater) => {
    let groessen;

    try {
        groessen = JSON.parse(berater.getAttribute('data-fn-groessenberater'));
    } catch (e) {
        return;
    }

    if (!Array.isArray(groessen) || !groessen.length) {
        return;
    }

    const ergebnis = berater.querySelector('[data-fn-gb-ergebnis]');
    const ergebnisName = berater.querySelector('[data-fn-gb-groessename]');
    const ergebnisZusatz = berater.querySelector('[data-fn-gb-zusatz]');
    const masse = berater.querySelector('[data-fn-gb-masse]');
    const leer = berater.querySelector('[data-fn-gb-leer]');
    const gewohntChips = [].slice.call(berater.querySelectorAll('[data-fn-gb-gewohnt]'));
    const passformChips = [].slice.call(berater.querySelectorAll('[data-fn-gb-passform]'));

    let gewohnt = null;
    let verschiebung = 0;

    const rechnen = () => {
        if (gewohnt === null) {
            ergebnis.hidden = true;
            if (leer) { leer.hidden = false; }
            return;
        }

        // Die Oberteile sind oversized geschnitten: die gewohnte Groesse
        // sitzt wie gedacht. Wer es koerpernah oder noch weiter will,
        // landet eine Stufe darunter oder darueber.
        const index = Math.min(groessen.length - 1, Math.max(0, gewohnt + verschiebung));
        const treffer = groessen[index];

        ergebnisName.textContent = treffer.name;
        ergebnisZusatz.textContent = treffer.zusatz || '';
        ergebnisZusatz.hidden = !treffer.zusatz;

        if (masse) {
            const zeilen = massZeile('Länge', treffer.laenge)
                + massZeile('Brust', treffer.brust)
                + massZeile('Schulter', treffer.schulter)
                + massZeile('Ärmel', treffer.aermel);

            masse.innerHTML = zeilen;
            masse.hidden = zeilen === '';
        }

        ergebnis.hidden = false;
        if (leer) { leer.hidden = true; }
    };

    const merken = (liste, aktiv) => {
        liste.forEach((c) => c.setAttribute('aria-pressed', c === aktiv ? 'true' : 'false'));
    };

    gewohntChips.forEach((chip) => {
        chip.addEventListener('click', () => {
            gewohnt = parseInt(chip.getAttribute('data-fn-gb-gewohnt'), 10) || 0;
            merken(gewohntChips, chip);
            rechnen();
        });
    });

    passformChips.forEach((chip) => {
        chip.addEventListener('click', () => {
            verschiebung = parseInt(chip.getAttribute('data-fn-gb-passform'), 10) || 0;
            merken(passformChips, chip);
            rechnen();
        });
    });
});
